module.exports = __webpack_public_path__ + "img/user-check-solid.8fac9745.svg";